import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { LocationInterface, LocationInterfaceWithId } from '@sk/sk-interfaces';
import { finalize, map } from 'rxjs/operators';
import { LocalStorageService } from 'services/local-storage.service';
import { fromPromise } from 'rxjs/internal-compatibility';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class LocationService {


  constructor(private firestoreService: AngularFirestore,
              private storageService: LocalStorageService) {
  }


  addLocationByImport(locationData: LocationInterface) {
    const organizationId = this.storageService.getOrganizationId();
    return fromPromise(
      this.firestoreService
        .collection('organizations').doc(organizationId)
        .collection('locations').add(locationData))
      .pipe(
        map(res => {
          const exists = true;
          const id = res.id;
          return {...locationData, id, exists } as LocationInterfaceWithId;
        }));
  }


  // NGRX RELATED FUNCTIONS
  queryStateChangesLocations() {
    console.log(`RUN LOCATIONS QUERY - ${moment().format('HH:mm:ss')}`);
    const organizationId = this.storageService.getStorage('organizationId');
    return this.firestoreService.collection('organizations').doc(organizationId)
      .collection<LocationInterfaceWithId>('locations')
      .stateChanges()
      .pipe(
        finalize(() => console.log('LOCATIONS QUERY DONE'))
      )

  }


  updateLocationById(locationData: LocationInterfaceWithId, id: string) {
    const organizationId = this.storageService.getOrganizationId();
    const updateLocationObj = {
      ...locationData
    };
    if (updateLocationObj.id) {
      delete updateLocationObj.id;
    }
    if (updateLocationObj.exists) {
      delete updateLocationObj.exists;
    }
    return fromPromise(
      this.firestoreService
        .collection('organizations').doc(organizationId)
        .collection('locations').doc(id).update(updateLocationObj))
      .pipe(
        map(() => {
          const exists = true;
          const location = { ...locationData, id, exists } as LocationInterfaceWithId;
          return location;
        }));
  }


  addLocationByNgrx(locationData: LocationInterfaceWithId) {
    const organizationId = this.storageService.getOrganizationId();
    const newLocationObj = {
      ...locationData
    };
    if (newLocationObj.id) {
      delete newLocationObj.id;
    }
    if (newLocationObj.exists) {
      delete newLocationObj.exists;
    }
    return fromPromise(
      this.firestoreService
        .collection('organizations').doc(organizationId)
        .collection('locations').add(newLocationObj))
      .pipe(
        map(res => {
          const exists = true;
          const id = res.id;
          return { ...locationData , id, exists} as LocationInterfaceWithId;
        }));
  }


}
